@if (isLoading) {
    <div>
        <div class="background"></div>
        <div class="container">
            <div class="spinner-box">
                <mat-spinner diameter="50"></mat-spinner>
            </div>
        </div>
    </div>
} @else {
    <app-landing-page-base [headerText]="headerText" [contentText]="contentText"/>
}